import { IconChevronDown } from '@tabler/icons-react-native'
import { clsx } from 'clsx'
import { forwardRef } from 'react'
import { type View } from 'react-native'

import { Icon, Pressable, Text, type SingleSelectTargetProps } from '@/components'

export type PromptSelectTargetProps = Omit<SingleSelectTargetProps, 'ref'> & {
  testID?: string
}

// Picker target for prompt selection. Mirrors the default single-select field (white box,
// chevron) but lets the full question wrap across multiple lines instead of truncating, since
// the user is answering that question and needs to read all of it.
export const PromptSelectTarget = forwardRef<View, PromptSelectTargetProps>(
  ({ accessibilityLabel, displayValue, isDisabled, isExpanded, onPress, placeholder, testID }, ref) => (
    <Pressable
      accessibilityLabel={accessibilityLabel}
      accessibilityRole='combobox'
      accessibilityState={{
        disabled: isDisabled,
        expanded: isExpanded
      }}
      aria-haspopup='listbox'
      className={clsx(
        'min-h-10 flex-row items-center justify-between gap-2 rounded bg-white px-3 py-2',
        isDisabled && 'opacity-40'
      )}
      disabled={isDisabled}
      onPress={onPress}
      ref={ref}
      testID={testID}
    >
      <Text className='flex-1 font-poppinsRegular text-base color-black'>{displayValue || placeholder}</Text>
      <Icon
        aria-hidden
        as={IconChevronDown}
        className='color-black'
      />
    </Pressable>
  )
)

PromptSelectTarget.displayName = 'PromptSelectTarget'
